import React from 'react';
import {Team} from '../../services';

export type AppNavigationContextType = {
  selectedTeam?: Team;
  setSelectedTeam: React.Dispatch<React.SetStateAction<Team | undefined>>;
  sidebarVisible: boolean;
  setSidebarVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AppNavigationContext = React.createContext<
  AppNavigationContextType | undefined
>(undefined);
